export default __webpack_public_path__ + "static/media/thank-you-checkmark.c4f86969.png";